import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { compact, uniq } from 'lodash-es'

import { type AppViewNavigation } from '@/components/templates/AppView'
import { useTeams } from '@/model/contexts/useTeams.ts'

export function useTeamBaseDropdown(): Pick<AppViewNavigation, 'teamBaseOptions'> {
  const intl = useIntl()
  const { teams } = useTeams()

  return useMemo(() => {
    const bases = uniq(teams.map(({ base }) => base))
    return {
      teamBaseOptions: {
        placeholder: intl.formatMessage({ id: 'selector.base.label' }),
        options: [
          {
            text: intl.formatMessage({ id: 'selector.base.all' }),
            value: 'all',
          },
          ...compact(bases).map((value) => ({
            text: intl.formatMessage({ id: 'selector.base.value' }, { value }),
            value,
          })),
        ],
      },
    }
  }, [intl, teams])
}
